// extracted by mini-css-extract-plugin
export default {"root":"UserHistoryDrawerRejectedCommentsQuery-root-6e741b0f8a61b7198f362a568ce4550f","callout":"UserHistoryDrawerRejectedCommentsQuery-callout-d70e59bc2cf22546ce190fe6932e0821"};